module.exports = __webpack_public_path__ + "img/volvo-wordmark-footer.9ea7e7ec.svg";